import type { BankAccount } from "@/model/account";
import type { Payment } from "@/model/payment";

export const getPayment = async (id: string): Promise<Payment> => {
  const url = `/api/payment/${id}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPayment exception: ${error}`);
    throw error;
  }
};

export const getPosPayment = async (id: string): Promise<{ id: string }> => {
  const url = `/api/pos/${id}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPosPayment exception: ${error}`);
    throw error;
  }
};

export const initPayment = async (
  id: string,
  phoneNumber?: string,
  debtorCorpExternalId?: string,
  externalId?: string,
): Promise<Payment> => {
  const url = `/api/payment/${id}`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ debtorCorpExternalId, externalId, phoneNumber }),
    });
    if (!resp.ok) {
      throw resp;
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPayment exception: ${error}`);
    throw error;
  }
};

export const initWalletPayment = async (
  paymentId: string,
  authType: string,
  account: BankAccount,
): Promise<{ id: string, consentExpired: boolean }> => {
  const url = `/api/payment/wallet/${paymentId}`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ authType, accountId: account.id, userId: account.userId }),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`initWalletPayment exception: ${error}`);
    throw error;
  }
};

export const patchPayment = async (
  id: string,
  phoneNumber?: string,
  externalId?: string,
  debtorCorpExternalId?: string,
  expiresAt?: number,
): Promise<Payment> => {
  const url = `/api/payment/${id}`;
  try {
    const resp = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        debtorCorpExternalId,
        externalId,
        phoneNumber,
        expiresAt,
      }),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPayment exception: ${error}`);
    throw error;
  }
};

export const cancelPayment = async (id: string): Promise<Payment> => {
  const url = `/api/payment/${id}`;
  try {
    const resp = await fetch(url, {
      method: "DELETE",
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`cancelPayment exception: ${error}`);
    throw error;
  }
}
